import React, {useState} from 'react';
import { useEffect } from 'react';
import {Link} from 'react-router-dom';
import styled from 'styled-components';

export const DropdownMenu = ({trigger, items, className}) => {

  const [showItems, setShowItems] = useState(false)
  const toggleItems = e => {
    e.preventDefault()

    // stop click from bubbling to the top and triggering "hideItems"
    e.stopPropagation()

    setShowItems(true)
  }
  const hideItems = e => {
    setShowItems(false)
  }

  const cx = ['plus-dropdown', className].filter(Boolean).join(' ')

  useEffect(() => {
    window.document.addEventListener('click', hideItems)

    return () => {
      window.document.removeEventListener('click', hideItems)
    }
  }, [])

  return (
    <Wrapper>
      <div className={cx}>
        <button className="plus-dropdown__trigger btn btn-sm" onClick={toggleItems}>{trigger}</button>

        {showItems &&
          <ul className="plus-dropdown__items border shadow p-0">
            {items.map((item, i) =>
                <li className='plus-dropdown__item-wrap px-3 py-1' onClick={item.onClick} key={i}>
                  {item.link
                    ? <Link to={item.link}><Item item={item}/></Link>
                    : <Item item={item}/>
                  }
                </li>
              )}
          </ul>
        }

      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div.withConfig({displayName: '-Wrapper'})`
  position: relative;

  & .plus-dropdown__items {
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 1000;
    background: white;
    list-style-type: none;
  }

  & .plus-dropdown__item-wrap:hover {
    background: lightgray;
    cursor: pointer;
  }
`

const Item = ({item}) => {
  return (
    <div className='plus-dropdown__item'>
      {item.icon &&
        <i className={'plus-dropdown__item--icon ' + item.icon}></i>
      }

      <div className='plus-dropdown__item-text'>{item.text}</div>
    </div>
  )
}